import axios from 'axios'
import Cookies from 'js-cookie'


class MosaicAPI {
  constructor(base) {
    this.client = axios.create({
      baseURL: base ? base : `${window.location.origin}/apps/mosaic-api/`,
    })
    this.client.interceptors.response.use((response) => {
      // Just return the data on 2xx responses.
      return response.data;
    }, (error) => {
      console.log(error)

      if (error.response && error.response.status === 403) {
        getErrorLogger().error('Redirecting to login from Mosaic API request.', error)
        this._redirectToLogin()
      }
      return Promise.reject(error);
    });
  }

  get(endpoint, params = {}) {
    return this.client.get(
      endpoint,
      {
        params: params,
        headers: this.buildHeaders()
      }
    )
  }

  post(endpoint, data) {
    return this.client.post(
      endpoint,
      data,
      { headers: this.buildHeaders() }
    )
  }

  put(endpoint, data) {
    return this.client.put(
      endpoint,
      data,
      { headers: this.buildHeaders() }
    )
  }

  buildHeaders() {
    const token = Cookies.get('r_token')
    const hash = Cookies.get('c_hash')

    if (!token || !hash) {
      getErrorLogger().error('Redirecting to login from Mosaic API request: Missing auth cookies.', Cookies.get())
      this._redirectToLogin()
    }

    return {
      "accept": "application/json",
      'Content-Type': 'application/json',
      'X-Recharge-Token': token,
      'X-Customer-Hash': hash
    }
  }

  _redirectToLogin() {
    window.location.assign('/tools/recurring/login')
  }
}


class ThemeEngineAPI {
  constructor(base) {
    this.client = axios.create({
      baseURL: base ? base : `${window.location.origin}/tools/recurring/portal/`,
      headers: {
        'accept': 'application/json, text/javascript, */*; q=0.01',
        'Content-Type': 'application/json',
      },
    })
    this.client.interceptors.response.use((response) => {
      // Just return the data on 2xx responses.
      return response.data;
    }, (error) => {
      console.log(error)

      // Hack for now - authentication failures unfortunately come through as network errors.
      // This is because the server redirects us to the login page on the wrong domain (which
      // the browser blocks due to CORS). Recharge is supposedly working on changing the redirect
      // to a 401/403.
      if (error.message === 'Network Error') {
        getErrorLogger().error('Redirecting to login from ThemeEngine API request', error)
        this._redirectToLogin()
      }
      return Promise.reject(error);
    });
  }

  get(endpoint, params = {}) {
    return this.client.get(
      this.buildUrl(endpoint),
      {
        params: this.buildParams(params),
      }
    )
  }

  request_objects(schema) {
    return this.client.get(
      this.buildUrl('/request_objects'),
      {
        params: this.buildParams({schema: schema}),
      }
    )
  }

  post(endpoint, data) {
    return this.client.post(
      this.buildUrl(endpoint),
      data,
      {
        params: this.buildParams(),
      }
    )
  }

  buildUrl (endpoint, params = {}) {
    const customerHash = Cookies.get('c_hash');

    if (!customerHash ) {
      getErrorLogger().error('Redirecting to login from Theme Engine API request: Missing auth cookies.', Cookies.get())
      this._redirectToLogin();
    }

    return  `${customerHash}${endpoint}`;
  }

  buildParams(params = {}) {
    const token = Cookies.get('r_token');

    if (!token) {
      getErrorLogger().error('Redirecting to login from Theme Engine API request: Missing auth cookies.', Cookies.get())
      this._redirectToLogin();
    }

    params['token'] = token;
    return params;
  }

  _redirectToLogin() {
    window.location.assign('/tools/recurring/login')
  }
}

function getErrorLogger() {
  return window.Rollbar || console;
}

export {
  ThemeEngineAPI,
  MosaicAPI,
  getErrorLogger
}
